import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const flex = css`
  display: flex;
`;

export const Flex = styled.div`
  ${flex};
`;
